<template>
    <div class="sidebar-shell d-flex flex-column flex-shrink-0 sticky-top" id="sidebar" :class="{show:sidebarShow}" :style="'width: ' + width + 'px;'">
        <a href="/" class="sidebar-logo-link text-white text-decoration-none">
            <div class="logo">
                <img v-if="locale=='ru' || locale=='en'" src="../assets/img/logo-text-ru-white.webp" class="img-fluid static-img" :alt="$t('header.logo_alt')">
                <img v-if="locale=='kk' "src="../assets/img/logo-text-kz-white.webp" class="img-fluid static-img" :alt="$t('header.logo_alt')">
            </div>
        </a>
        <ul class="sidebar-nav nav flex-column mb-auto scroll-enabled">
            <sidebar-child v-for="(n, index) in _navs" :key="index" ref="childComponent" @sidebarHide="sidebarHide" @exposeToggle="(fn) => $emit('exposeToggle', fn)"
            :item="n" :inboxCount="inboxCount" :outboxCount="outboxCount"></sidebar-child>
            <div class="sidebar-logout rel width-100">
                <li class="nav-item">
                    <button type="button" @click.prevent="logout()" class="nav-link width-100">
                        <i class="bi bi-door-open-fill"></i>
                        <span>{{ $t('sidebar.logout') }}</span>
                    </button>
                </li>
            </div>
        </ul>
        <div class="sidebar-footer">
            <div v-if="isMobileViewport" class="sidebar-mobile-preferences">
                <div class="sidebar-mobile-language">
                    <LangSwitcher />
                </div>
                <div class="sidebar-mobile-theme">
                    <button
                        type="button"
                        class="sidebar-theme-toggle nav-link"
                        :aria-label="currentTheme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'"
                        :title="currentTheme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'"
                        @click="toggleTheme"
                    >
                        <span class="sidebar-theme-icons" aria-hidden="true">
                            <i class="bi bi-sun-fill theme-icon" :class="{ active: currentTheme === 'light' }"></i>
                            <i class="bi bi-moon-fill theme-icon" :class="{ active: currentTheme === 'dark' }"></i>
                        </span>
                    </button>
                </div>
            </div>
            <small class="build-version">{{ $t('sidebar.build-version') + getAppVersion() }}</small>
        </div>
    </div>
    <button
        type="button"
        class="mobile-sidebar-toggle"
        :class="{ 'sidebar-open': sidebarShow }"
        :style="{ '--sidebar-width': width + 'px' }"
        :aria-label="sidebarShow ? $t('mobile-tabs.close-menu') : $t('mobile-tabs.menu')"
        :title="sidebarShow ? $t('mobile-tabs.close-menu') : $t('mobile-tabs.menu')"
        @click="sidebarShow = !sidebarShow"
    >
        <i class="bi" :class="sidebarShow ? 'bi-x' : 'bi-list'" aria-hidden="true"></i>
    </button>
    <nav class="mobile-navbar navbar navbar-expand-lg fixed-bottom" id="mobileNavbar">
        <div id="mobileNavbarNav">
            <ul class="navbar-nav flex-row justify-content-between">
                <li class="nav-item">
                    <router-link type="button" class="btn btn-link" to="/dashboard" :aria-label="$t('mobile-tabs.main')" @click="sidebarCollapse()">
                        <i class="bi bi-house-fill" aria-hidden="true"></i>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link type="button" class="btn btn-link" to="/claims/new" :aria-label="$t('mobile-tabs.claim')" @click="sidebarCollapse()">
                        <i class="bi bi-file-earmark-plus-fill" aria-hidden="true"></i>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link type="button" class="btn btn-link" to="/claims/inbox" :aria-label="$t('mobile-tabs.inbox')" @click="sidebarCollapse()">
                        <i class="bi bi-inboxes-fill" aria-hidden="true"></i>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link type="button" class="btn btn-link" to="/notifications" :aria-label="$t('mobile-tabs.notifications')" @click="sidebarCollapse()">
                        <i class="bi bi-bell-fill" aria-hidden="true"></i>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link type="button" class="btn btn-link" to="/settings/profile" :aria-label="$t('mobile-tabs.profile')" @click="sidebarCollapse()">
                        <i class="bi bi-person-circle" aria-hidden="true"></i>
                    </router-link>
                </li>
            </ul>
        </div>
    </nav>
    <PolicyAgreementModal ref="policyAgreementModal" @agreed="agreed" />
    <AgreementFetchFailModal ref="agreementFetchFailModal" @logout="logout" />
    <SetPasswordModal ref="setPasswordModal" @passwordSet="passwordSet" />
    <ClaimPreviewModal ref="claimPreviewModal" @closed="handleClaimPreviewClose" />
    <DebtPreviewModal ref="debtPreviewModal" @closed="handleDebtPreviewClose" />
    <NotifySenderModal ref="notifySenderModal" :notice="debt_notice" @closed="handleNotifySenderClose" />
</template>

<script>
    import SidebarChild from './SidebarChild.vue';
    import Menu from './menu.json'
    import AgreementFetchFailModal from './settings/AgreementFetchFailModal.vue'
    import PolicyAgreementModal from './settings/PolicyAgreementModal.vue'
    import { rates } from '../../libs/rate'
    import ChangePasswordModal from './settings/ChangePasswordModal.vue'
    import SetPasswordModal from './settings/SetPasswordModal.vue'
    import ClaimPreviewModal from './claims/ClaimPreviewModal.vue'
    import DebtPreviewModal from './debt/PreviewModal.vue'
    import NotifySenderModal from './debt/NotifySenderModal.vue'
    import LangSwitcher from './LangSwitcher.vue'
    import { getResolvedTheme, setTheme } from '../theme'

    export default {
        data: () => ({
            width: 280,
            navs: Menu,
            inboxCount: 0,
            outboxCount: 0,
            sidebarShow: false,
            agreedToPolicy: false,
            currentPlan: {},
            hasPassword: false,
            isOsi: false,
            showDebtNoticeMenu: false,
            debt_notice: {},
            currentTheme: 'light',
            isMobileViewport: window.innerWidth <= 991
        }),
        components: {
            PolicyAgreementModal,
            AgreementFetchFailModal,
            ChangePasswordModal,
            SetPasswordModal,
            ClaimPreviewModal,
            SidebarChild,
            DebtPreviewModal,
            NotifySenderModal,
            LangSwitcher
        },
        computed: {
            _navs: {
                get() {
                    let locales = {
                        'dashboard': this.$t('sidebar.dashboard'),
                        'claims': this.$t('sidebar.claims'),
                        'new-claim': this.$t('sidebar.new-claim'),
                        'import-claims': this.$t('sidebar.import-claims'),
                        'inbox-claim': this.$t('sidebar.inbox-claim'),
                        'utility-debts-inbox-claim': this.$t('sidebar.utility-debts-inbox-claim'),
                        'cash-loans-inbox-claim': this.$t('sidebar.cash-loans-inbox-claim'),
                        'products-inbox-claim': this.$t('sidebar.products-inbox-claim'),
                        'outbox-claim': this.$t('sidebar.outbox-claim'),
                        'recipients': this.$t('sidebar.recipients'),
                        'add-recipients': this.$t('sidebar.add-recipients'),
                        'debt-notifications': this.$t('sidebar.debt-notifications'),
                        'new-debt-notification': this.$t('sidebar.new-debt-notification'),
                        'debt-notification-import': this.$t('sidebar.debt-notification-import'),
                        'outbox-debt-notification': this.$t('sidebar.outbox-debt-notification'),
                        'inbox-debt-notification': this.$t('sidebar.inbox-debt-notification'),
                        'settings': this.$t('sidebar.settings'),
                        'payment-schedules': this.$t('sidebar.payment-schedules'),
                        'profile-settings': this.$t('sidebar.profile-settings'),
                        'bonus-account': this.$t('sidebar.bonus-account'),
                        'payment-settings': this.$t('sidebar.payment-settings'),
                        'permissions': this.$t('sidebar.permissions'),
                        'users': this.$t('sidebar.users'),
                        'osi': this.$t('sidebar.osi'),
                        'manage-osi': this.$t('sidebar.manage-osi'),
                    }

                    const navs = this.navs.filter(nav => {
                        if(nav.slug === 'osi') return this.isOsi
                        if(nav.slug === 'manage-osi') return Number(this.$store.state.user?.role_id) === 1
                        if(nav.slug === 'debt-notifications') return this.showDebtNoticeMenu

                        return true
                    })

                    // translate
                    for(let i in navs) {
                        navs[i].text = navs[i].slug in locales ? locales[navs[i].slug] : navs[i].slug

                        if(navs[i].sub!=[]) {
                            navs[i].sub = this.addSubText(locales, navs[i].sub)
                        }
                    }

                    return navs
                }
            },
            locale() {
                const locale = this.$i18n.locale;
                return locale
            }
        },
        methods: {
            addSubText(locales, navs) {
                for(let j in navs ?? []) {
                    navs[j].text = navs[j].slug in locales ? locales[navs[j].slug] : navs[j].slug
                    if(navs[j].sub!=[]) {
                        navs[j].sub = this.addSubText(locales, navs[j].sub)
                    }
                }
                return navs
            },
            getAppVersion() {
                return process.env.VUE_APP_VERSION
            },
            getUsername() {
                if(this.$store.state.user) {
                    let username = [this.$store.state.user.settings?.firstName, this.$store.state.user.settings?.lastName, this.$store.state.user.settings?.patronymic].filter(Boolean).join(' ')

                    return username || 'Пользователь'
                }

                return 'Пользователь'
            },
            getInboxCount() {
                let url = process.env.VUE_APP_API_URL + '/claims/inbox-count'

                axios.get(url, {
                    withCredentials: true
                }).then((response) => {
                    let r = response.data

                    if(r.result = 'SUCCESS') {
                        if(r.data >= 0) this.inboxCount = r.data

                        this.$emit('updatedInboxCount', this.inboxCount)

                        // if(this.inboxCount > 0) {
                        //     this.$store.commit('showModal', {
                        //         title: 'Новые уведомление',
                        //         body: `<p>Количество новых уведомлений: ${this.inboxCount}</p>`
                        //     })
                        // }
                    } else {
                        this.$notify({
                            title: this.$t('notify.types.error'),
                            text: 'Не удалось проверить количество входящих',
                            type: 'error'
                        })
                    }
                })
            },
            getOutboxCount() {
                let url = process.env.VUE_APP_API_URL + '/claims/outbox-count'

                axios.get(url, {
                    withCredentials: true
                })
                .then((response) => {
                    let r = response.data

                    if(r.result = 'SUCCESS') {
                        if(r.data >= 0) this.outboxCount = r.data

                        this.$emit('updatedOutboxCount', this.outboxCount)
                    } else {
                        this.$notify({
                            title: this.$t('notify.types.error'),
                            text: 'Не удалось проверить количество исходящих' + r.result,
                            type: 'error'
                        })
                    }
                })
            },
            getInboxCountForNav() {
                if(this.inboxCount > 99) return '99+'
                return this.inboxCount
            },
            getOutboxCountForNav() {
                if(this.outboxCount > 99) return '99+'
                return this.outboxCount
            },
            logout() {
                this.$store.commit('clearClaim')
                
                const url = process.env.VUE_APP_API_URL + '/logout'

                axios.get(url, {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }).then(response => response).then(async res => {
                    let r = await res.data

                    if (r.result === 'SUCCESS') {
                        this.$store.commit('logout')
                        this.$router.push('/login/main')
                    } else {
                        this.email = '', this.password = ''
                        console.error('Auth failed')
                    }
                })
            },
            checkMyRecipient() {
                // if is user logged right now, else return
                if(!this.$store.state.loggedNow) return
                this.$store.state.loggedNow = false

                let recipient = {
                    user_id: this.$store.state.user.id,
                    firstName: this.$store.state.user.settings?.firstName ?? '',
                    lastName: this.$store.state.user.settings?.lastName ?? '',
                    patronymic: this.$store.state.user.settings?.patronymic ?? '',
                    id_no: this.$store.state.user.settings?.iinBin ?? '',
                    companyIdNum: this.$store.state.user.settings?.bin ?? '',
                    companyName: this.$store.state.user.settings?.organization ?? ''
                }

                // check if id_no empty
                if(!recipient.id_no) return

                let url = process.env.VUE_APP_API_URL + '/recipients/set-me'

                axios.post(url, recipient, {
                    withCredentials: true
                }).then((response) => {
                    let r = response.data
                    
                    if(r.result === 'SUCCESS') {
                        let has = r.data // true (has recipient with this id_no) | false (not found)

                        this.getInboxCount()
                        if(!has) this.createMyRecipient()
                    } else {
                        
                    }
                })
            },
            createMyRecipient() {
                // create recipient with this id_no
                let recipient = {
                    user_id: this.$store.state.user.id,
                    title: this.$store.state.user.username,
                    firstName: this.$store.state.user.settings?.firstName,
                    lastName: this.$store.state.user.settings?.lastName,
                    patronymic: this.$store.state.user.settings?.patronymic ?? '',
                    id_no: this.$store.state.user.settings?.iinBin ?? '',
                    companyIdNum: this.$store.state.user.settings?.bin ?? '',
                    companyName: this.$store.state.user.settings?.organization ?? '',
                    email: this.$store.state.user.settings?.email ?? '',
                    phone: this.$store.state.user.settings?.phone ?? '',
                    address: this.$store.state.user.settings?.address ?? '',
                    creator: this.$store.state.user.id
                }

                let url = process.env.VUE_APP_API_URL + '/recipients/add'

                axios.post(url, recipient, {
                    withCredentials: true
                }).then((response) => {
                    let r = response.data
                    
                    if(r.result === 'SUCCESS') {
                        
                    } else {
                        
                    }
                })
            },
            async checkPolicyAgreement() {
                let url = process.env.VUE_APP_API_URL + '/users/agreement'

                await axios.get(url, {
                    withCredentials: true
                }).then(async (response) => {
                    let r = response.data

                    if(r.result === 'SUCCESS') { // if there is agreement record in db
                        if(r.data === 1) { // if user already agreed
                            this.agreedToPolicy = true

                            await this.checkPassword()

                            if(!this.hasPassword) {
                                this.$store.commit('modalShow', { id: 'setPasswordModal' })
                            }
                        } else { // if user has not agreed
                            this.$store.commit('modalShow', { id: 'policyAgreementModal' })
                        }
                    } else { // if no agreement record, create one
                        this.agreedToPolicy = false

                        await this.createAgreement()
                    }
                })
            },
            sidebarCollapse(disabled = false) {
                if(!disabled) {
                    this.sidebarShow = false
                }
            },
            sidebarHide() {
                //hide sidebar if mobile
                this.sidebarShow = false
            },
            async createAgreement() {
                let url = process.env.VUE_APP_API_URL + '/users/create-agreement'

                await axios.get(url, {
                    withCredentials: true
                }).then((response) => {
                    let r = response.data

                    if(r.result === 'SUCCESS') { // if new agreement created
                        this.$store.commit('modalShow', { id: 'policyAgreementModal' })
                    } else {
                        this.$store.commit('modalShow', { id: 'agreementFetchFailModal'}) // show modal saying 'failed to create policy agreement, please log out'
                    }
                })
            },
            createAccountBalance(user_id) {
                let url = process.env.VUE_APP_API_URL + '/accounts/my'
                axios.post(url, {user_id}, {
                    withCredentials: true,
                })
                .then((response) => {
                    let r = response.data
                    if (r.result === 'SUCCESS') {

                    }
                })
            },
            createBonusAccountBalance(user_id) {
                let url = process.env.VUE_APP_API_URL + '/bonus-accounts/my'
                axios.post(url, {user_id}, {
                    withCredentials: true,
                })
                .then((response) => {
                    let r = response.data
                    if (r.result === 'SUCCESS') {

                    }
                })
            },
            setDefaultRate() {
                let url = process.env.VUE_APP_API_URL + '/rates/set-current'
                axios.post(url, {rateId: 'default'}, {
                    withCredentials: true,
                })
                .then((response) => {
                    let r = response.data
                    if (r.result === 'SUCCESS') {

                    }
                })
            },
            async getCurrentPlan() {
                let url = process.env.VUE_APP_API_URL + '/rates/get-current-plan'

                await axios.get(url, {
                    withCredentials: true
                }).then((response) => {
                    let r = response.data

                    if(r.result === 'SUCCESS') {
                        this.currentPlan = r.data
                        if(this.currentPlan.id !== rates.enterprise || !this.currentPlan.import) { // if not enterprise OR import blocked
                            for(let nav of this.navs) {
                                if(nav.link === '/claims/inbox') {
                                    const index = nav.sub.findIndex(s => s.link === '/claims/import')
                                    if(index > -1) nav.sub.splice(index, 1)
                                }
                            }
                        }
                    } else {
                        for(let nav of this.navs) {
                            if(nav.link === '/claims/inbox') {
                                const index = nav.sub.findIndex(s => s.link === '/claims/import')
                                if(index > -1) nav.sub.splice(index, 1)
                            }
                        }
                    }
                })

                this.$emit('updatedCurrentPlan', this.currentPlan)
            },
            async debtNoticeMenu() {
                this.showDebtNoticeMenu = false

                if(!this.$store.state.user?.settings) return

                let isOsi = await this.$api.checkOsiStatus()
                this.isOsi = isOsi === true

                if(this.isOsi) { // if osi
                    this.showDebtNoticeMenu = true

                    for(let k in this.navs) {
                        if(this.navs[k].sub) {
                            if(Array.isArray(this.navs[k].sub)) {
                                this.navs[k].sub = this.navs[k].sub.filter(item => item.link !== '/debt-notice/inbox')
                            }
                        }
                    }
                } else {
                    let r = await this.$api.checkNotices()


                    if(r.result === 'SUCCESS') {
                        this.showDebtNoticeMenu = !!r.data

                        if(r.data) {
                            for(let k in this.navs) {
                                if(this.navs[k].sub) {
                                    if(Array.isArray(this.navs[k].sub)) {
                                        this.navs[k].sub = this.navs[k].sub.filter(item => item.link !== '/debt-notice/new')
                                        this.navs[k].sub = this.navs[k].sub.filter(item => item.link !== '/debt-notice/outbox')
                                        this.navs[k].sub = this.navs[k].sub.filter(item => item.link !== '/debt-notice/import')
                                    }
                                }
                            }
                        }
                    } else {
                        this.showDebtNoticeMenu = false
                    }
                }
            },
            agreed() {
                this.agreedToPolicy = true

                this.checkPolicyAgreement()
            },
            passwordSet() {
                this.$refs.setPasswordModal.close()
            },
            async checkPassword() {
                let url = process.env.VUE_APP_API_URL + '/users/has-password'

                await axios.get(url, {
                    withCredentials: true
                }).then((response) => {
                    let r = response.data

                    if(r.result === 'SUCCESS') {
                        this.hasPassword = r.data
                    } else {
                        this.$notify({
                            title: this.$t('notify.types.error'),
                            text: this.$t('sidebar.notify.password-error'),
                            type: 'error'
                        })
                    }
                })
            },
            async getUnreadClaimPreview() {
                let r = await this.$api.getUnreadClaim()

                if(r.data ?? false) {
                    this.$refs.claimPreviewModal.claim = r.data
                    this.$refs.claimPreviewModal.refresh()
                    this.$store.commit('modalShow', { id: 'claimPreviewModal' })
                }
            },
            async getUnreadDebtNotice() {
                let r = await this.$api.getUnreadDebtNotice()
                
                if(r ?? false) {
                    if(r.result && r.result === 'ERROR') {
                        return
                    }

                    this.$refs.debtPreviewModal.notice = r
                    await this.$refs.debtPreviewModal.getSenderPhone()
                    await this.$refs.debtPreviewModal.getSenderTitle()
                    await this.$refs.debtPreviewModal.read(r.id)
                    this.$store.commit('modalShow', { id: 'debtNoticePreviewModal' })
                }
            },
            async checkNoticeStatuses() {
                let r = await this.$api.checkNoticeStatuses()

                if(r.result && r.result === "ERROR") {
                    return
                } else if (r.result === "SUCCESS") {
                    if(r.data) {
                        this.$store.commit('modalShow', { id: 'notifyNoticeSenderModal' })
                        this.updateNotice(r.data.id)
                        this.debt_notice = r.data
                    }
                }
            },
            async updateNotice(noticeId) {
                let r = await this.$api.setNoticeSenderNotified(noticeId)

                if(r.result === 'ERROR') {
                    this.$notify({
                        title: this.$t('notify.types.error'),
                        text: r.message,
                        type: 'error'
                    })
                }
            },
            cleanupBackdrops() {
                document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
                document.body.classList.remove('modal-open')
                document.body.style.overflow = ''
                document.body.style.paddingRight = ''
            },
            handleClaimPreviewClose() {
                this.cleanupBackdrops()
                this.getUnreadClaimPreview()
            },
            handleDebtPreviewClose() {
                this.cleanupBackdrops()
                this.getUnreadDebtNotice()
            },
            handleNotifySenderClose() {
                this.cleanupBackdrops()
                this.checkNoticeStatuses()
            },
            toggleTheme() {
                setTheme(this.currentTheme === 'dark' ? 'light' : 'dark')
            },
            themeChanged(event) {
                this.currentTheme = getResolvedTheme(event.detail)
            },
            viewportChanged() {
                this.isMobileViewport = window.innerWidth <= 991
            }
        },
        mounted() {
            this.currentTheme = getResolvedTheme()
            window.addEventListener('kdp-theme-change', this.themeChanged)
            window.addEventListener('resize', this.viewportChanged)

            this.checkPolicyAgreement()
            this.getInboxCount()
            this.getOutboxCount()
            this.checkMyRecipient()
            this.getAppVersion()
            this.createAccountBalance()
            this.createBonusAccountBalance()
            this.setDefaultRate()
            this.getCurrentPlan()

            this.debtNoticeMenu()
            this.getUnreadDebtNotice()
            this.checkNoticeStatuses()

            if(this.$libs.cookies.getCookie('claimPreview')) {
                this.$store.commit('modalShow', { id: 'claimPreviewModal' })
            } else {
                this.getUnreadClaimPreview()
            }

            this.$emit("exposeSidebarShow", () => {
                this.sidebarShow = !this.sidebarShow
            })
        },
        beforeUnmount() {
            window.removeEventListener('kdp-theme-change', this.themeChanged)
            window.removeEventListener('resize', this.viewportChanged)
        }
    }
</script>

<style scoped>
    .width-100 {
        width: 100%;
    }

    .disabled-on-pc {
        display: none;
    }

    .disabled-on-mobile {
        display: block;
    }

    #sidebar {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 280px;
        height: 100vh;
        color: var(--kdp-white);
        background: #131722;
        background-image:
            linear-gradient(160deg, rgba(82, 83, 168, 0.28) 0%, rgba(22, 19, 34, 0) 42%),
            linear-gradient(24deg, #111127 0%, #1f2037 52%, #2a254f 100%);
        border-right: 1px solid rgba(255, 255, 255, .08);
        box-shadow: 18px 0 45px rgba(18, 15, 42, 0.28);
        z-index: 3;
        transition: left .25s ease;
    }

    .sidebar-shell {
        padding: 18px 14px 12px;
    }

    .sidebar-logo-link {
        display: block;
        padding: var(--kdp-space-2) 10px 18px;
    }

    .logo {
        display: flex;
        align-items: center;
        max-width: 154px;
        min-height: 50px;
        margin: 0;
        user-select: none;
    }

    .static-img {
        max-height: 48px;
    }

    .sidebar-nav {
        gap: var(--kdp-space-1);
        padding: var(--kdp-space-2) 0 10px;
        user-select: none;
    }

    .scroll-enabled {
        overflow-y: auto;
        display: block !important;
        max-height: calc(100vh - 150px);
        padding-right: var(--kdp-space-1);
    }

    .scroll-enabled::-webkit-scrollbar,
    #sidebar::-webkit-scrollbar {
        width: 5px;
    }

    .scroll-enabled::-webkit-scrollbar-track,
    #sidebar::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, .05);
        border-radius: var(--kdp-radius-pill);
    }

    .scroll-enabled::-webkit-scrollbar-thumb,
    #sidebar::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, .22);
        border-radius: var(--kdp-radius-pill);
    }

    .nav-link,
    .btn-link {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        min-height: 42px;
        padding: 9px 12px;
        color: #e0def2;
        background: transparent;
        border: 1px solid transparent;
        border-radius: var(--kdp-radius-md);
        text-align: left;
        text-decoration: none;
        font-size: var(--kdp-font-size-sm);
        font-weight: var(--kdp-font-weight-medium);
        line-height: var(--kdp-line-height-snug);
        position: relative;
        transition: color .18s ease, background-color .18s ease, border-color .18s ease, box-shadow .18s ease;
    }

    .nav-link .bi,
    .btn-link .bi {
        flex: 0 0 22px;
        color: #958dff;
        font-size: 1.18rem;
        line-height: var(--kdp-line-height-tight);
    }

    .nav-link:hover,
    .btn-link:hover {
        color: var(--kdp-white);
        background: rgba(166, 160, 251, .12);
        border-color: rgba(166, 160, 251, .2);
    }

    .nav-link:focus,
    .btn-link:focus,
    #app .btn-link:active {
        color: var(--kdp-white);
        background: rgba(255, 255, 255, .1);
        border-color: #b9b4ff;
        box-shadow: 0 0 0 .2rem rgba(145, 167, 255, .16);
        outline: 0;
    }

    .nav-link.disabled {
        color: rgba(217, 222, 238, .42);
        pointer-events: none;
    }

    .nav-link.disabled .bi {
        color: rgba(145, 167, 255, .36);
    }

    .sidebar-logout {
        display: none;
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid rgba(255, 255, 255, .08);
    }

    .sidebar-logout .nav-link {
        color: #fecaca;
    }

    .sidebar-logout .nav-link .bi {
        color: #f87171;
    }

    .sidebar-logout .nav-link:hover,
    .sidebar-logout .nav-link:focus {
        color: var(--kdp-white);
        background: rgba(185, 28, 28, .18);
        border-color: rgba(248, 113, 113, .28);
    }

    .sidebar-footer {
        padding: var(--kdp-space-3) 10px 0;
    }

    .sidebar-mobile-preferences {
        display: none;
        flex-direction: column;
        gap: 6px;
        margin-bottom: 8px;
    }

    .sidebar-mobile-language,
    .sidebar-mobile-theme {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 42px;
        padding: 0 8px;
    }

    .sidebar-mobile-language :deep(.lang-switcher) {
        margin: 0;
    }

    .sidebar-mobile-language :deep(.lang-item) {
        padding: 0 .45rem;
        border-color: rgba(255, 255, 255, .22);
    }

    .sidebar-theme-toggle {
        display: none;
    }

    .sidebar-theme-icons {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        min-width: 45px;
    }

    .sidebar-theme-icons .theme-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        color: rgba(217, 222, 238, .5);
        font-size: 1.05rem;
        opacity: .65;
        transition: color .18s ease, opacity .18s ease, transform .18s ease;
    }

    .sidebar-theme-icons .theme-icon.active {
        color: var(--kdp-text-on-primary);
        background: var(--kdp-primary-strong);
        border-color: var(--kdp-primary-strong);
        opacity: 1;
        transform: scale(1.08);
    }

    [data-theme='dark'] .sidebar-theme-icons .theme-icon.active {
        color: var(--kdp-primary-deep);
        background: var(--kdp-primary-soft);
        border-color: var(--kdp-primary-soft);
    }

    [data-theme='light'] .sidebar-theme-icons .theme-icon:not(.active) {
        color: var(--kdp-primary);
        opacity: 1;
    }

    .sidebar-theme-label {
        display: inline;
    }

    .build-version {
        display: block;
        color: rgba(217, 222, 238, .55);
        font-size: .68rem;
        line-height: 1.3;
    }

    .badge {
        font-size: .65em;
    }

    #mobileNavbar {
        display: none;
        padding: var(--kdp-space-2) 12px;
        background: linear-gradient(160deg, var(--kdp-primary-deep) 0%, var(--kdp-primary-dark) 100%);
        border-top: 1px solid rgba(202, 198, 255, .2);
        box-shadow: 0 -12px 28px rgba(41, 32, 93, .32);
        backdrop-filter: blur(14px);
        z-index: 4;
    }

    .mobile-sidebar-toggle {
        display: none;
    }

    #mobileNavbarNav,
    #mobileNavbar .navbar-nav {
        width: 100%;
    }

    #mobileNavbar .nav-item {
        flex: 1 1 0;
        min-width: 0;
    }

    #mobileNavbar .btn-link {
        flex: 1 1 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 3px;
        min-height: 56px;
        width: 100%;
        margin: 0 2px;
        padding: 6px 10px;
        color: #d9deee;
        text-align: center;
        border: 1px solid transparent;
        border-radius: var(--kdp-radius-md);
    }

    #mobileNavbar .btn-link .bi {
        margin: 0;
        color: var(--kdp-primary);
        font-size: 1.5rem;
        line-height: 1;
    }

    #mobileNavbar .btn-link:hover,
    #mobileNavbar .btn-link:focus,
    #mobileNavbar .router-link-active {
        color: var(--kdp-white);
        background: rgba(166, 160, 251, .16);
        border-color: rgba(202, 198, 255, .34);
    }

    @media (max-width: 991px) {
        #sidebar {
            left: -100%;
            width: 100%;
        }

        .mobile-sidebar-toggle {
            position: fixed;
            top: 12px;
            left: 12px;
            z-index: 5;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 2.65rem;
            height: 2.65rem;
            color: var(--kdp-white);
            background: var(--kdp-primary-dark);
            border: 1px solid rgba(202, 198, 255, .45);
            border-radius: 50%;
            box-shadow: 0 6px 16px rgba(41, 32, 93, .3);
            transition: left .25s ease, color .18s ease, background-color .18s ease, border-color .18s ease;
        }

        .mobile-sidebar-toggle.sidebar-open {
            right: auto;
            left: calc(var(--sidebar-width) + 12px);
        }

        .mobile-sidebar-toggle:hover,
        .mobile-sidebar-toggle:focus-visible {
            background: var(--kdp-primary-strong);
            border-color: var(--kdp-primary-soft);
            outline: none;
        }

        #sidebar.show {
            left: 0;
        }

        .sidebar-shell {
            padding-bottom: 76px;
        }

        .sidebar-theme-toggle {
            display: flex;
            align-self: flex-start;
            width: 4.5rem;
            min-height: 2.35rem;
            justify-content: center;
            gap: 0;
            padding: 3px;
            margin-bottom: var(--kdp-space-2);
            border: 1px solid var(--kdp-border-default);
            border-radius: var(--kdp-radius-pill);
            background: var(--kdp-surface-inset);
        }

        .sidebar-logout {
            display: block;
        }

        .sidebar-mobile-preferences {
            display: flex;
        }

        .sidebar-theme-toggle:hover,
        .sidebar-theme-toggle:focus-visible,
        .sidebar-theme-toggle:focus,
        .sidebar-theme-toggle:active {
            background: var(--kdp-surface-hover);
            border-color: var(--kdp-primary-accent);
            outline: none;
        }

        .sidebar-theme-toggle .sidebar-theme-icons .theme-icon {
            display: inline-flex;
            width: 1.8rem;
            height: 1.75rem;
            flex: 0 0 1.8rem;
            justify-content: center;
            border: 1px solid transparent;
            border-radius: var(--kdp-radius-pill);
        }

        .sidebar-theme-toggle:focus,
        .sidebar-theme-toggle:active {
            background: var(--kdp-surface-inset) !important;
            border-color: var(--kdp-border-default);
        }

        .sidebar-theme-label {
            display: none;
        }

        .scroll-enabled {
            max-height: calc(100vh - 220px);
        }

        #mobileNavbar {
            display: block;
        }
    }
</style>
